// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34eXb","content":"styles_content__32VpR","row":"styles_row__1P-SV","footer":"styles_footer__3kAyA","phraseLength":"styles_phraseLength__2JJc1"};